import React, { forwardRef } from 'react';
/**
 * Custom link override component type
 * Apps can register a component to override link behavior (e.g., URL transformation in embeds)
 */
let CustomLinkOverride = null;
/**
 * Register a custom link override component
 * This allows apps to inject custom link behavior globally for overriding URLs
 *
 * @example
 * ```typescript
 * setCustomLinkOverride(EmbedCustomLinkOverride);
 * ```
 */
export const setCustomLinkOverride = (Component) => {
    CustomLinkOverride = Component;
};
/**
 * Base link component that can be customized via setCustomLinkOverride
 * Falls back to standard anchor tag if no override is registered
 */
export const BaseLink = forwardRef(({ children, ...restProps }, ref) => {
    if (CustomLinkOverride) {
        return React.createElement(CustomLinkOverride, { ref: ref, ...restProps }, children);
    }
    // eslint-disable-next-line thoughtspot-eslint/restrict-anchor-tags -- [SCAL-283577] Base link component implementation, foundational anchor tag that all Link components use
    return React.createElement("a", { ref: ref, ...restProps }, children);
});
//# sourceMappingURL=base-link.js.map